var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("view-loader", { attrs: { loading: !!_vm.loading } }, [
    _c("div", { staticClass: "portlet-body form" }, [
      _c("form", { staticClass: "form-horizontal", attrs: { role: "form" } }, [
        _c(
          "div",
          { staticClass: "form-body" },
          [
            _c(
              "h3",
              {
                staticClass: "form-section",
                staticStyle: { "margin-top": "0" }
              },
              [_vm._v(_vm._s(_vm._f("trans")("job.new")))]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "row margin-bottom-20" }, [
              _c("div", { staticClass: "col-md-12" }, [
                _c("div", { staticClass: "form-group" }, [
                  _c("label", { staticClass: "col-md-2 control-label" }, [
                    _vm._v(_vm._s(_vm._f("trans")("job.create.type")) + ":")
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "col-md-10" },
                    [
                      _c("single-select", {
                        attrs: {
                          "allow-empty": true,
                          options: _vm.jobTypes,
                          name: "jobTypes"
                        },
                        model: {
                          value: _vm.selectedType,
                          callback: function($$v) {
                            _vm.selectedType = $$v
                          },
                          expression: "selectedType"
                        }
                      })
                    ],
                    1
                  )
                ])
              ])
            ]),
            _vm._v(" "),
            _vm.selectedTypeOption
              ? _c(
                  _vm.selectedTypeOption.component,
                  _vm._b(
                    {
                      tag: "component",
                      attrs: { component: _vm.selectedTypeOption.id },
                      on: { loading: _vm.showLoader }
                    },
                    "component",
                    _vm.selectedTypeOption.props,
                    false
                  )
                )
              : _vm._e()
          ],
          1
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5b1fe335", { render: render, staticRenderFns: staticRenderFns })
  }
}